export enum Shortcut {
  COMMAND_SHIFT_S,
  COMMAND_SHIFT_B
}
